import React from "react";
import TimeAgo from "react-timeago";
import { cleanDate } from "../../../../util/app";

const FoodIntakeList = ({ items = [], onView }) => {
    if (items.length < 1)
        return (
            <div className="text-center text-pink">
                <i className="material-icons" style={{ fontSize: "4em" }}>
                    info
                </i>
                <br />
                <strong>No Food intake has been added yet</strong>
            </div>
        );
    return (
        <table className="table table-bordered">
            <thead>
                <tr>
                    <th style={{ width: "10%" }} className="text-center">
                        SN
                    </th>
                    <th style={{ width: "30%" }}>Meal</th>
                    <th style={{ width: "30%" }}>Food Offered</th>
                    <th style={{ width: "20%" }}>Date & Time</th>
                    <th style={{ width: "10%" }} className="text-center">
                        View
                    </th>
                </tr>
            </thead>
            <tbody>
                {items.map((item, index) => (
                    <tr key={index}>
                        <td className="text-center">
                            <strong>{index + 1}</strong>
                        </td>
                        <td className="view-message">
                            <span>{item.meal}</span>
                            <br />
                            <small className="text-muted">
                                <TimeAgo date={item.created_at}></TimeAgo>
                            </small>
                        </td>
                        <td className="view-message">
                            <span>{item.foodOffered}</span>
                            <br />
                            <small className="text-primary">
                                <strong>Amount Taken: {item.amountTaken}</strong>
                            </small>
                        </td>
                        <td className="view-message">{cleanDate(item.datetime)}</td>

                        <td className="view-message text-center">
                            <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                <i className="material-icons text-primary">trending_flat</i>
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default FoodIntakeList;
